import * as API from "@/api/index.js"

export default {
  data() {
    return {
      cbh_const:"thzk",
     show_aside:true,//是否显示左侧树形结构
      row_style: {height: '27.1px',padding:'0px'},
      cell_style: {padding: "0px"},
      header_row_style:{height: '24px',padding:'0px'} ,
      header_cell_style:{height: '24px',padding:'0px'},
      left_width: 260,   // 左侧环境栏宽度
    }
  },
  methods: {
      // 左侧环境栏宽度变化
      left_width_change(val){
        this.left_width = val;
      },

      show_msg(message,type="success",title="", position="", timeOut=0){
        
        if(title ==""){
          if(type == "success"){
            title="操作成功"
          }else if(type=="warning"){
            title="警告！"
          }else if(type =="error"){
            title="错误!"
          }else if(type == "info"){
            title= "提示"
          }
        }
        if(position === "") position = "bottom right";
        if(timeOut === 0) {
          timeOut = 3000;
          if(type === "error") timeOut = 6000;
        }
        let obj = {type:type,title:title,message:message,"position":position,"timeOut":timeOut}

      
        
         if(type == "success"){
             this.$toast.success(obj)
          }else if(type=="warning"){
           
            this.$toast.warn(obj)
          }else if(type =="error"){
              this.$toast.error(obj)
          }else if(type== "info"){
              this.$toast.info(obj)
         }

      },

      async get_sys_code(sys_type){
        let data = {"page": 1, "size": 1000, "sys_code_type":sys_type}
        const response = await API.GET("/omnis/system/sys_code/", data)
        let result = response.data
        let sys_code_list = result.data
        return sys_code_list
      },
    array2dict(list,name,value){
      let data_dict={}

      list.map((item)=>{
        let data_name = item[name]
        let data_value = ""
        if(value){
           data_value = item[value]
        }else {
          data_value = item
        }
        data_dict[data_name]= data_value
      })
      return data_dict
    },
     showAside(val){
        this.show_aside = val
      },
    //搜索ip格式化ip内容
    formatter_ip(server_ip, search_value) {
      if (!search_value) {
        return server_ip
      }

      var fuzzy_byte = new RegExp(search_value, 'g');
      var server_id_color = server_ip.replace(fuzzy_byte, '<span id="result" style="background:yellow;color:red;">' + search_value + '</span>');
      return server_id_color
    },
     S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      },
      guid() {
        return (this.cbh_const+this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4());
      },




    formatter_date(date) {
        var day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
        var month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : "0"
            + (date.getMonth() + 1);
        var hor = date.getHours();
        var min = date.getMinutes() < 10 ? "0" + date.getMinutes(): date.getMinutes();
        var sec = date.getSeconds() < 10 ? "0" + date.getSeconds(): date.getSeconds();
        return date.getFullYear() + '-' + month + '-' + day + " " + hor + ":" + min + ":" + sec;
    },

    is_JSON(str) {
          var result = {
            "result":null,
            "msg":"",
          }
          if (typeof str == 'string') {
              try {
                  var obj=JSON.parse(str);
                  if(typeof obj == 'object' && obj ){
                    result.result = true

                  }else{
                    result.result = false
                    result.msg = "格式有误!"

                  }

              } catch(e) {
                  result.result = false
                  result.msg = "格式有误：" + e

              }
          }else {
            result.result = false
            result.msg = "不是字符串！"
          }

          return result
      },


    $_timestamp_formatDate(datetime) {
        if(!datetime){
          return ""
        }
        if(datetime.toString().length == 10){
          datetime = datetime * 1000
        }
        var date = new Date(datetime);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var year = date.getFullYear(),
            month = ("0" + (date.getMonth() + 1)).slice(-2),
            sdate = ("0" + date.getDate()).slice(-2),
            hour = ("0" + date.getHours()).slice(-2),
            minute = ("0" + date.getMinutes()).slice(-2),
            second = ("0" + date.getSeconds()).slice(-2);
        // 拼接
        var result = year + "/"+ month +"/"+ sdate +" "+ hour +":"+ minute +":" + second;
        // 返回
        return result;
    },


    $_get_uuid(){
      var token_id = require('node-uuid').v4();
      return token_id
    },

    // startsWith适配低版本Chrome
    $_startsWith(target, str, ignorecase){
      return ignorecase ? str.toLowerCase().indexOf(target.toLowerCase()) === 0 : str.indexOf(target) === 0;
    },

    // 定义一个深拷贝函数  接收目标target参数
     $_deepClone(target) {
        // 定义一个变量
        let result;
        // 如果当前需要深拷贝的是一个对象的话
        if (typeof target === 'object') {
        // 如果是一个数组的话
            if (Array.isArray(target)) {
                result = []; // 将result赋值为一个数组，并且执行遍历
                for (let i in target) {
                    // 递归克隆数组中的每一项
                    result.push(this.$_deepClone(target[i]))
                }
             // 判断如果当前的值是null的话；直接赋值为null
            } else if(target===null) {
                result = null;
             // 判断如果当前的值是一个RegExp对象的话，直接赋值
            } else if(target.constructor===RegExp){
                result = target;
            }else {
             // 否则是普通对象，直接for in循环，递归赋值对象的所有值
                result = {};
                for (let i in target) {
                    result[i] = this.$_deepClone(target[i]);
                }
            }
         // 如果不是对象的话，就是基本数据类型，那么直接赋值
        } else {
            result = target;
        }
         // 返回最终结果
        return result;
      },


      $_time_formatter_spacing(start_time) {   //  获取某时间距离此刻的间隔时间量
        var end_time = this.$_get_local_data();
        end_time = end_time.replace(/-/g, "/");
        var current_date = new Date(end_time);
        if (start_time != undefined) {
          start_time = start_time.toString()
          start_time = start_time.replace(/-/g, "/");
        }
        var start_data = new Date(start_time)
        var existed = (current_date - start_data) / 1000;
        var secondTime = parseInt(existed);// 秒
        var minuteTime = 0
        var hourTime = 0;// 小时
        var daytime = 0; //天数
        if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
          //获取分钟，除以60取整数，得到整数分钟
          minuteTime = parseInt(secondTime / 60);
          //获取秒数，秒数取佘，得到整数秒数
          secondTime = parseInt(secondTime % 60);
          //如果分钟大于60，将分钟转换成小时
          if (minuteTime > 60) {
            //获取小时，获取分钟除以60，得到整数小时
            hourTime = parseInt(minuteTime / 60);
            //获取小时后取佘的分，获取分钟除以60取佘的分
            minuteTime = parseInt(minuteTime % 60);
          }
          //如果小时大于24，将小时转化为天数
          if (hourTime > 24) {
            daytime = parseInt(hourTime / 24)
          }
        }
        var result = "" + parseInt(secondTime) + "s ";

        if (minuteTime > 0) {
          result = "" + parseInt(minuteTime) + "m " + result;
        }
        if (hourTime > 0) {
          result = "" + parseInt(hourTime) + "h " + result;
        }
        if (daytime > 0) {
          result = "" + parseInt(daytime) + "days"
        }
        return result
      },

    $_get_local_data() {   // 获取此刻的时间
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        var currentdate = year + seperator1 + month + seperator1 + strDate + ' ' + h + ':' + m + ':' + s;
        return currentdate;
      },


      // 按指定字段排序,
      $sort_by_field(property, sort_key) {    // property ：指定字段， sort_key： 1 升序，否则 倒叙
          return function(a,b){
              sort_key = sort_key || 1;   // 默认升序
              var value1 = typeof a[property] === 'string' ? a[property].toLowerCase() : a[property];
              var value2 = typeof b[property] === 'string' ? b[property].toLowerCase() : b[property];

              if ((!value1 && value1 !== 0) || (!value2 && value2 !== 0)){
                if (!value1 && !value2){
                  return 1;
                }else if (!value1){
                  return 1;
                }else {
                  return -1;
                }
              }else {
                return value1 > value2 ? (sort_key === 1 ? 1 : -1) : (sort_key === 1 ? -1 : 1);
              }
          }
      },



  }
}




// WEBPACK FOOTER //
// ./src/components/common_page/mixin/table_style.js